import { enumOptionsToObject } from './enum-helpers'

export const RegionOptions = [
  'CentralRockyMountains',
  'GreatLakes',
  'NewEngland',
  'NorthCentral',
  'NorthernRockyMountains',
  'South',
  'Southeast',
  'West'
] as const
export const Regions = enumOptionsToObject(RegionOptions)
export type Region = (typeof RegionOptions)[number]

export const RegionLabels: { [key in Region]: string } = {
  CentralRockyMountains: 'Central Rocky Mountains',
  GreatLakes: 'Great Lakes',
  NewEngland: 'New England',
  NorthCentral: 'North Central',
  NorthernRockyMountains: 'Northern Rocky Mountains',
  South: 'South',
  Southeast: 'Southeast',
  West: 'West'
}
